// extracted by mini-css-extract-plugin
module.exports = {"body":"fonts_body__2t3L8","small":"fonts_small__24Ac-","regular":"fonts_regular__2dcYS","semibold":"fonts_semibold__9knNk","bold":"fonts_bold__1AotT"};